<template>  
  <div class="gantt-container">
    <b-table-simple small bordered responsive>
      <b-thead>
        <b-tr>
          <b-th 
            sticky-column
            class="gantt-left-column text-secondary"
          >Изменения</b-th>
          <b-th
            v-for="hour in periodOfHours"
            :key="$moment(hour).valueOf()"
            class="gantt-column text-secondary"
          >
          {{ $moment(hour).format('DD.MM.YYYY HH:00') }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="(active, t_index, index) in activities"
          :key="t_index"
        >
          <b-th class="gantt-left-column" sticky-column>
            <p class="mb-1 mt-2 font-weight-bold" :title="`${active.length} изменений(ия)`">{{ t_index }} / {{ activities[t_index][0].user.name }}</p>
    
            <div class="gantt-group mb-2">
              <div
                v-for="act in active"
                :key="act.id"
                class="gantt-element"
              >
                {{ act.property_name }}: {{ act.property_value }}
              </div>
            </div>
          </b-th>
          <b-td
            v-for="hour in periodOfHours"
            :key="$moment(hour).valueOf()"
          >
            <template v-if="$moment(hour).format('HH') === $moment(t_index).format('HH')">
              <div 
                class="gantt-graph-bar"
                :style="`background-color: ${colors[index]};`"
                :title="`Изменения сделаны ${t_index}`"
              >
                <div class="gantt-graph-text">
                  Изменений: {{ active.length }}
                </div>
              </div>
            </template> 
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-th variant="secondary" class="gantt-left-column" sticky-column>
            <div class="text-right font-weight-normal">
              Всего изменений: <span class="font-weight-bold">{{ summeryCountOfChanges }}</span>
            </div>
          </b-th>
          <b-td :colspan="periodOfHours.length ? periodOfHours.length:1" variant="secondary"></b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
import colorArray from '@/constants/colorArray';

export default {
  props: {
    activities: {
      type: Object,
      default: () => [],
    }
  },
  data() {
    return {
      colors: colorArray,
      periodOfHours: [],
      summeryCountOfChanges: 0
    }
  },
  mounted() {
    this.periodOfHours = this.getPeriodOfHours();
  },
  methods: {
    sortDates() {
      let dates = [];

      for (let key in this.activities) {
        this.activities[key].forEach(act => dates.push(act.formatted_created_at));
        this.summeryCountOfChanges += this.activities[key].length;
      }

      return dates
    },
    getMinDate() {
      let min = this.sortDates().map(t => this.$moment(t, 'DD.MM.YYYY HH:mm'));
      return this.$moment.min(min);
    },
    getMaxDate() {
      let max = this.sortDates().map(t => this.$moment(t, 'DD.MM.YYYY HH:mm'));
      return this.$moment.max(max);
    },
    getPeriodOfHours() {
      const start = this.getMinDate();
      const end = this.getMaxDate();
      const dates = [this.$moment({ ...start })];

      while (start.hour() !== end.hour()) {
        start.add(1, 'hour');
        dates.push(this.$moment({ ...start }));
      }
      return dates
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~/components/ui/kanban/gantt.scss';
</style>